export function getGridPageArray(maxPage: number, currentPage: number): (number | string)[] {
  if (maxPage <= 5) {
    return Array.from({ length: maxPage }, (_, index) => index + 1);
  }
  if (currentPage <= 4) {
    return [1, 2, 3, 4, 5, '...', maxPage];
  }
  if (currentPage >= maxPage - 3) {
    return [1, '...', maxPage - 4, maxPage - 3, maxPage - 2, maxPage - 1, maxPage];
  }
  return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', maxPage];
}
